<template>
  <div class="h-screen flex overflow-hidden" :class="bgColorClass">
    <the-mobile-sidebar
      :sidebarOpen="sidebarOpen"
      @updateSidebarOpen="updateSidebarOpen"
    ></the-mobile-sidebar>

    <the-sidebar />

    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <the-header
        :sidebarOpen="sidebarOpen"
        @updateSidebarOpen="updateSidebarOpen"
      ></the-header>
      <main
        class="flex-1 relative z-0 overflow-y-auto py-6 focus:outline-none"
        tabindex="0"
      >
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
import TheMobileSidebar from "@/components/global/TheMobileSidebar";
import TheSidebar from "@/components/global/TheSidebar";
import TheHeader from "@/components/global/TheHeader";

export default {
    components: { TheMobileSidebar, TheSidebar, TheHeader },
    data() {
        return {
            sidebarOpen: false,
            open: false
        };
    },
    methods: {
        updateSidebarOpen(bool) {
            this.sidebarOpen = bool;
        }
    },
    computed: {
        bgColorClass() {
            return this.$route.meta.bgClass
                ? this.$route.meta.bgClass
                : "bg-gray-100";
        }
    }
};
</script>

<style scoped lang="scss">
.menu-popover-enter {
  @apply transform opacity-0 scale-95;
}
.menu-popover-leave-to {
  @apply transform opacity-0 scale-95;
}
.menu-popover-enter-to {
  @apply transform opacity-100 scale-100;
}
.menu-popover-leave {
  @apply transform opacity-100 scale-100;
}
.menu-popover-enter-active {
  @apply transition ease-out duration-100;
}
.menu-popover-leave-active {
  @apply transition ease-in duration-75;
}
</style>
